/* eslint-disable react/no-array-index-key */
/* eslint-disable object-shorthand */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import thumbnailImg from 'assets/images/tumbnailImg.svg';
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from 'chart.js';
import CN from 'classnames';
import { Button, Input } from 'components/atoms';
import { ComplexDateRangePicker } from 'components/atoms/ComplexDateRangePicker';
import {
  useGetCCActivityInMins,
  useGetCCExportReport,
  useGetCCStats,
  useGetCCStatsForEarnings,
  useGetCCTop10Videos,
} from 'framework/api/methods';
import React, { FC, useEffect, useRef, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export interface ContentCreatorViewProps {
  [x: string]: any;
}

export const ContentCreatorView: FC<ContentCreatorViewProps> = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();

  const notify = (message: any, type: any) => {
    if (type === 'error') {
      toast.error(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    if (type === 'success') {
      toast.success(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const [isOpenDatePicker, setIsOpenDatePicker] = useState(false);
  const [currentMonthEarnings, setCurrentMonthEarnings] = useState('');
  const [lastMonthEarnings, setLastMonthEarnings] = useState('');
  const [top10Videos, setTop10Videos] = useState([]);
  const [watchData, setWatchData] = useState([]);
  const [selectedDate, setSelectedDate] = useState({
    startDate: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    endDate: new Date(),
  });

  const onSuccessDashboardStats = (data: any) => {
    //
  };

  const onSuccessDashboardVideos = (data: any) => {
    setTop10Videos(data?.videos ?? []);
  };

  const onErrorDashboardStats = ({ response: { data: errData }, response }: any) => {
    if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
      notify('Session expired.', 'error');
      setTimeout(() => {
        navigate('/auth/login');
        localStorage.clear();
      }, 2000);
    } else {
      notify(errData?.message || 'Something went wrong.', 'error');
    }
  };

  const onErrorDashboardVideos = ({ response: { data: errData }, response }: any) => {
    if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
      notify('Session expired.', 'error');
      setTimeout(() => {
        navigate('/auth/login');
        localStorage.clear();
      }, 2000);
    } else {
      // notify(errData?.message || 'Something went wrong.', 'error');
    }
  };

  /** Get all cards API */
  const { refetch: getDashboardStats, data } = useGetCCStats(
    { id: id?.toString() || '' },
    onSuccessDashboardStats,
    onErrorDashboardStats,
  );
  const { refetch: getDashboardTop10Videos } = useGetCCTop10Videos(
    { id: id?.toString() || '' },
    onSuccessDashboardVideos,
    onErrorDashboardVideos,
  );

  const { mutate: getDashboardStatsForEarningsMutate } = useGetCCStatsForEarnings();

  const getPreviousMonth = () => {
    const date = new Date();
    date.setMonth(date.getMonth() - 1);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `${year}/${month}`;
  };

  // function to request Otp for registered / unregistered users
  const getDashboardStatsForEarnings = () => {
    getDashboardStatsForEarningsMutate(
      {
        date: getPreviousMonth(),
        id: id?.toString() || '',
      },
      {
        onSuccess: ({ data: successData }: any) => {
          setLastMonthEarnings(successData?.data?.earnings);
          setCurrentMonthEarnings(successData?.data?.currentEarnings);
        },
        onError: ({ response: { data: errData }, response }: any) => {
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  const { mutate: getDashboardActivityInMinsMutate } = useGetCCActivityInMins();
  const { mutate: getDashboardExportReportMutate, isLoading: getDashboardExportReportIsLoading } =
    useGetCCExportReport();

  const formatToYYYYMMDD = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // function to request Otp for registered / unregistered users
  const getDashboardActivityInMins = () => {
    getDashboardActivityInMinsMutate(
      {
        startDate: formatToYYYYMMDD(selectedDate.startDate),
        endDate: formatToYYYYMMDD(selectedDate.endDate),
        id: id?.toString() || '',
      },
      {
        onSuccess: ({ data: successData }: any) => {
          setWatchData(successData?.data);
        },
        onError: ({ response: { data: errData }, response }: any) => {
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  // function to export report
  const getDashboardExportReport = () => {
    getDashboardExportReportMutate(
      {
        startDate: formatToYYYYMMDD(selectedDate.startDate),
        endDate: formatToYYYYMMDD(selectedDate.endDate),
        id: id?.toString() || '',
      },
      {
        onSuccess: ({ data: successData }: any) => {
          const blob = new Blob([successData]);

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `activity-in-minutes-report-${formatToYYYYMMDD(
            selectedDate.startDate,
          )}-${formatToYYYYMMDD(selectedDate.endDate)}.xlsx`; // Customize the file name
          document.body.appendChild(link);
          link.click();

          // Cleanup
          link.remove();
          window.URL.revokeObjectURL(url);
        },
        onError: ({ response: { data: errData }, response }: any) => {
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  useEffect(() => {
    getDashboardStats();
    getDashboardStatsForEarnings();
    getDashboardTop10Videos();
  }, []);

  useEffect(() => {
    getDashboardActivityInMins();
  }, []);

  const chartData = {
    labels: watchData?.map((entry: any) => entry?.date),
    datasets: [
      {
        label: 'Watch Time (minutes)',
        data: watchData?.map((entry: any) => Number(entry?.watch_time_minutes)),
        backgroundColor: '#C40D42',
        borderRadius: 6,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context: any) {
            const index = context?.dataIndex;
            const entry: any = watchData?.[index];
            const minutes = entry?.watch_time_minutes || 0;
            const seconds = entry?.leftover_seconds || 0;

            return [`Watch Time (minutes): ${minutes}`, `Leftover Seconds: ${seconds}`];
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value: number | string) {
            if (typeof value === 'number') {
              return value >= 1000 ? `${value / 1000}k` : value;
            }
            return value;
          },
        },
      },
    },
  };

  const pickerRef: any = useRef(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (pickerRef.current && !pickerRef.current.contains(event.target as Node)) {
        getDashboardActivityInMins();
        setIsOpenDatePicker(false);
      }
    }

    if (isOpenDatePicker) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpenDatePicker, setIsOpenDatePicker]);

  const formatViews = (views: any) => {
    if (views >= 1_000_000) {
      return `${(views / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`;
    }
    if (views >= 1_000) {
      return `${(views / 1_000).toFixed(1).replace(/\.0$/, '')}K`;
    }
    return views ?? 0;
  };

  const formatDate = (date: Date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = String(date.getFullYear()).slice(-2);
    return `${day} ${month} ${year}`;
  };

  const formatWatchTime = (min: number, sec: number) => {
    const parts: string[] = [];

    if (min > 0) {
      parts.push(`${min < 10 ? '0' : ''}${min} Mn`);
    }

    if (sec > 0) {
      parts.push(`${sec < 10 ? '0' : ''}${sec} Sec`);
    }

    return parts.join(' ');
  };

  return (
    <div className="flex gap-5 w-full h-full p-5 lg:flex-row flex-col lg:overflow-hidden overflow-y-auto">
      <div className="flex flex-col gap-5 lg:w-3/5 w-full h-auto">
        <div className="flex gap-x-3">
          <i
            className="ri-arrow-left-long-line pb-0 text-2xl leading-none font-bold text-[#C40D42] cursor-pointer"
            onClick={() => {
              navigate('/content-creators');
            }}
          />
          <div className="text-[#05004E] text-xl leading-[26px] font-medium capitalize">
            {location?.state?.creatorName}
          </div>
        </div>
        <div className="card-summary bg-white lg:h-auto h-auto px-4 py-3 rounded-[20px] flex flex-col justify-between shadow-sm">
          <div className="font-semibold text-lg text-[#05004E]">Summary</div>

          <div className="flex justify-between items-center gap-x-3 pt-2">
            <div className="w-1/4 max-w-1/4 h-[164px] bg-[#FFE2E5] rounded-2xl p-3">
              <div className="flex items-start justify-between w-full">
                <div className="h-10 w-10 rounded-full bg-[#FA5A7D] flex justify-center items-center">
                  <i className="ri-eye-fill text-white text-[22px] leading-none" />
                </div>
                {/* <div className="border border-[#FA5A7D] rounded px-3 w-fit flex justify-center items-center hover:bg-[#f9cfd8]">
                  <i className="ri-arrow-right-long-line text-[#FA5A7D] text-[16px] leading-none cursor-pointer " />
                </div> */}
              </div>
              <div className="text-2xl text-[#151D48] font-semibold pt-4">
                {formatViews(data?.stats?.total_views)}
              </div>
              <div className="text-base text-[#425166] font-medium">Total Views</div>
            </div>

            <div className="w-1/4 max-w-1/4 h-[164px] bg-[#FFF4DE] rounded-2xl p-3">
              <div className="flex items-start justify-between w-full">
                <div className="flex gap-x-2 justify-start items-center">
                  <div className="h-10 w-10 rounded-full bg-[#FF947A] flex justify-center items-center">
                    <i className="ri-timer-line text-white text-[22px] leading-none" />
                  </div>
                  <div className="text-[#FF947A] font-semibold">Watch Time</div>
                </div>
                {/* <div className="border border-[#FF947A] rounded px-3 w-fit flex justify-center items-center hover:bg-[#fbddd6]">
                  <i className="ri-arrow-right-long-line text-[#FF947A] text-[16px] leading-none cursor-pointer " />
                </div> */}
              </div>
              {/* <div className="text-2xl text-[#151D48] font-semibold pt-4">
                {' '}
                {formatViews(data?.stats?.total_watch_minutes)}
              </div>
              <div className="text-base text-[#425166] font-medium">Total Minutes</div> */}
              <div className="text-xl text-[#151D48] font-semibold pt-1 flex flex-col">
                {formatViews(data?.stats?.total_watch_time)} mins
                <div className="text-sm text-[#425166] font-medium leading-none">Total</div>
              </div>

              <div className="text-xl text-[#151D48] font-semibold pt-2">
                {formatViews(data?.stats?.totalForMonetization)} mins
                <div className="text-sm text-[#425166] font-medium  leading-none">
                  For Monetization
                </div>
              </div>
            </div>

            <div className="w-1/4 max-w-1/4 h-[164px] bg-[#DCFCE7] rounded-2xl p-3">
              <div className="flex items-start justify-between w-full">
                <div className="h-10 w-10 rounded-full bg-[#3CD856] flex justify-center items-center">
                  <i className="ri-folder-video-fill text-white text-[22px] leading-none" />
                </div>
                {/* <div className="border border-[#3CD856] rounded px-3 w-fit flex justify-center items-center hover:bg-[#d4f4d9]">
                  <i className="ri-arrow-right-long-line text-[#3CD856] text-[16px] leading-none cursor-pointer " />
                </div> */}
              </div>
              <div className="text-2xl text-[#151D48] font-semibold pt-4">
                {data?.stats?.total_videos || 0}
              </div>
              <div className="text-base text-[#425166] font-medium">Total Videos</div>
            </div>

            <div className="w-1/4 max-w-1/4 h-[164px] bg-[#F3E8FF] rounded-2xl p-3">
              <div className="flex items-start justify-between w-full">
                <div className="flex gap-x-2 justify-start items-center">
                  <div className="h-10 w-10 rounded-full bg-[#BF83FF] flex justify-center items-center">
                    <i className="ri-money-dollar-box-line text-white text-[22px] leading-none" />
                  </div>
                  <div className="text-[#BF83FF] font-semibold">Earnings</div>
                </div>
                {/* <div className="border border-[#BF83FF] rounded px-3 w-fit flex justify-center items-center hover:bg-[#e9d7fc]">
                  <i className="ri-arrow-right-long-line text-[#BF83FF] text-[16px] leading-none cursor-pointer " />
                </div> */}
              </div>
              <div className="text-xl text-[#151D48] font-semibold pt-1">
                {currentMonthEarnings || 0} LKR
                <div className="text-sm text-[#425166] font-medium leading-none">Current Month</div>
              </div>

              <div className="text-xl text-[#151D48] font-semibold pt-2">
                {lastMonthEarnings || 0} LKR
                <div className="text-sm text-[#425166] font-medium leading-none">Last Month</div>
              </div>
            </div>
          </div>
        </div>
        <div className="card-chart bg-white lg:h-full h-auto px-4 py-3 rounded-[20px] shadow-sm flex flex-col">
          <div className="flex justify-between items-end w-full gap-x-3">
            <div className="font-semibold text-lg text-[#05004E]">Activity in Mins Watched</div>
            <div className="flex justify-end items-end gap-x-2">
              <div className="w-fit">
                <Input
                  value={`${formatDate(selectedDate.startDate)} - ${formatDate(
                    selectedDate.endDate,
                  )}`}
                  icon="ri-calendar-line !text-[#0F3659] !text-sm"
                  onclick={() => {
                    setIsOpenDatePicker(!isOpenDatePicker);
                  }}
                  inputClassName="border border-[#C3D3E2] !text-sm !rounded-lg w-[220px] !h-[37.6px] !text-[#0F3659] cursor-pointer"
                />

                <div
                  className={CN(
                    'fixed h-full bg-black bg-opacity-40 flex justify-center items-center z-50 shadow-lg top-0 bottom-0 right-0 left-0',
                    {
                      hidden: !isOpenDatePicker,
                    },
                  )}
                >
                  <div className="bg-white  border border-neutral-200" ref={pickerRef}>
                    <ComplexDateRangePicker
                      isResponsive
                      isEnableClearButton={false}
                      selectedDate={[selectedDate?.startDate, selectedDate?.endDate]}
                      onChange={(dates: any) => {
                        setSelectedDate({
                          startDate: dates?.startDate,
                          endDate: dates?.endDate,
                        });
                      }}
                      onClose={() => {
                        setIsOpenDatePicker(false);
                        getDashboardActivityInMins();
                      }}
                      showDateDisplay={false}
                      isStaticRanges
                      isRangesDisable
                    />
                  </div>
                </div>
              </div>

              <Button
                appearance="secondary"
                onClick={() => {
                  getDashboardExportReport();
                }}
                isLoading={getDashboardExportReportIsLoading}
              >
                <i className="ri-upload-2-line pr-2" />
                Export
              </Button>
            </div>
          </div>

          <div className="flex-1 pt-5 h-[200px] w-full">
            <Bar data={chartData} options={chartOptions} />
          </div>
        </div>
      </div>
      <div className="card-list bg-white p-4 lg:w-2/5 rounded-[20px] w-full h-auto lg:overflow-y-auto overflow-visible shadow-sm">
        <div className="font-semibold text-lg text-[#05004E]">Top Videos</div>

        <div className="pt-5 flex flex-col w-full">
          <div className="flex justify-between w-full text-[#96A5B8] pb-2 mb-1 border-b border-[#EDF2F6]">
            <div className="w-4/12 text-xs">Thumbnail</div>
            <div className="w-8/12 text-xs text-left">Title</div>
          </div>

          <div className="w-full flex flex-col lg:overflow-y-auto h-full">
            {top10Videos?.map((video: any, index) => (
              <div
                className="flex justify-between w-full text-[#444A6D] py-3 border-b gap-x-2 border-[#EDF2F6]"
                key={index}
              >
                <div className="w-4/12 text-xs">
                  <img
                    src={video?.cover_image_url}
                    alt="img-video"
                    className="h-[80px] w-[180px] object-cover rounded"
                  />
                </div>
                <div className="w-8/12 text-xs flex flex-col justify-between items-start">
                  <div className="text-sm font-medium text-[#63717A] max-w-[400px] h-full max-h-[70px] overflow-y-auto">
                    {video?.title}
                  </div>

                  <div className="flex gap-x-1">
                    <i className="ri-eye-fill text-[#C40D42] text-[20px] leading-6" />
                    <div className="text-[14px] leading-6 text-[#63717A]">
                      {video.view_count || 0}
                    </div>

                    <i className="ri-time-fill text-[#C40D42] text-[20px] leading-6 pl-3" />
                    <div className="text-[14px] leading-6 text-[#63717A]">
                      {formatWatchTime(video.watch_time_minutes, video.leftover_seconds) || 0}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentCreatorView;
